import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonToolbar,
  Checkbox,
  DatePicker,
  FlexboxGrid,
  Form,
  SelectPicker,
} from "rsuite";

import "./StoreScheduleFilters.css";
import { updateIn } from "json-immut";
import { HelperServices } from "../../../core/services/HelperServices";
import { get } from "lodash/fp";
import { StoreScheduleListParams } from "./StoreScheduleDataTypes";
import {
  dateFormatObj,
  messageTypeArr,
  roleTypeArr,
  statusObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { StoreServices } from "../../../core/services/StoreServices";
import { getItemFor, isEmptyVal } from "../../../utils/helpers";
import moment from "moment";

export interface PropTypesInterface {
  onSubmit: Function;
  onClear: Function;
}

export default function StoreScheduleFilters({
  onSubmit,
  onClear,
}: PropTypesInterface) {
  const { t } = useTranslation();
  const initSearchFormData = {
    schedule_date: new Date(moment().format(dateFormatObj.moment_y_m_d)),
    store: UtilityServices.getLoggedInUser("store_id"),
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] =
    useState<StoreScheduleListParams>(initSearchFormData);
  const company = useSelector((state: any) => state.company);
  const [storeGroupList, setStoreGroupList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [showFilter, setShowFilter] = useState(true);
  const handleSearchToggle = () => setShowFilter(!showFilter);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  function handleStoreChanges(value: any) {
    let form = formData;
    if (isEmptyVal(value)) {
      form = updateIn(form, ["store_group"], "");
      form = updateIn(form, ["store"], "");
    } else {
      form = updateIn(
        form,
        ["store_group"],
        getItemFor(value, "store_group_id", storeList)
      );
      form = updateIn(form, ["store"], value);
    }
    setFormData(form);
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex] = date;
    setFormData({ ...frmObj });
  };

  async function init() {
    try {
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    storeGroupSearch("", company.id);
    storeSearch("", company.id);
  }, [company.id]);

  async function storeGroupSearch(searchGroup?: string, forComp?: number) {
    let compId: number = getCompanyId(forComp);

    if (!compId) {
      setStoreGroupList([]);
      return;
    }
    let params: any = { smart_search: searchGroup };
    if (compId) {
      params.company = compId;
      params.sort_by = "region_id";
      params.sort_order = "asc";
    }
    try {
      const res = await StoreServices.getStoreGroups(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setStoreGroupList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function storeSearch(searchStore?: string, forComp?: number) {
    let compId: number = getCompanyId(forComp);

    if (!compId) {
      setStoreList([]);
      return;
    }
    let params: any = { smart_search: searchStore };
    if (compId) {
      params.company = compId;
      params.sort_by = "store_name";
      params.sort_order = "asc";
    }
    try {
      const res = await StoreServices.getStores(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setStoreList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function getCompanyId(forComp?: number) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = forComp ? forComp : company.id;
    }
    return compId;
  }

  function clearSearch() {
    onClear();
    setFormData(initSearchFormData);
  }

  const handleDefaultScheduleCheck = (value: any, checked: any) => {
    let form = updateIn(formData, ["is_default"], checked ? value : "");
    setFormData(form);
  };

  const handleMultiScheduleCheck = (value: any, checked: any) => {
    let form = updateIn(
      formData,
      ["new_schedule_everyday"],
      checked ? value : ""
    );
    setFormData(form);
  };

  const handleEventCheck = (value: any, checked: any) => {
    let form = updateIn(formData, ["type"], checked ? value : "");
    setFormData(form);
  };

  return (
    <div>
      <div className="row mb-2">
        <ButtonToolbar>
          <Button onClick={handleSearchToggle}>
            {" "}
            {t("STORE_SCHEDULE")} {t("ADVANCE_SEARCH")}
          </Button>
        </ButtonToolbar>
      </div>
      {showFilter && (
        <div className="content mb-3 pb-0">
          <Form
            formValue={formData}
            onChange={(data: any) => {
              let form = { ...formData, ...data };
              setFormData(form);
            }}
            layout="inline"
          >
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="store_group">
                  <Form.ControlLabel>
                    {t("STORE")} {t("GROUP")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={storeGroupList}
                    onSearch={(e: any) => {
                      if (e) {
                        //storeGroupSearch(e);
                      }
                    }}
                    valueKey="id"
                    labelKey="region_group_name"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "store_group", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "store_group", value: "" });
                    }}
                    name="store_group"
                    value={formData?.store_group}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="store">
                  <Form.ControlLabel>{t("STORE")}</Form.ControlLabel>
                  <SelectPicker
                    data={storeList}
                    onSearch={(e: any) => {
                      if (e) {
                        storeSearch(e);
                      }
                    }}
                    valueKey="id"
                    labelKey="store_name"
                    onSelect={(value, item) => {
                      handleStoreChanges(value);
                    }}
                    onClean={(e: any) => {
                      storeSearch("");
                      handleStoreChanges("");
                    }}
                    name="store"
                    value={formData?.store}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="schedule_date">
                  <Form.ControlLabel>
                    {t("SCHEDULE")} {t("DATE")}
                  </Form.ControlLabel>
                  <DatePicker
                    value={formData?.schedule_date}
                    format={dateFormatObj.calendar_d_m_y}
                    name="schedule_date"
                    id="schedule_date"
                    onChange={(e: any) => {
                      handleDateChange(e, "schedule_date");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <div className="filter-btn">
              <Button onClick={() => clearSearch()}>{t("CLEAR_FILTER")}</Button>
              <Button onClick={() => onSubmit(formData)}>{t("Search")}</Button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
}
